import { observable, action } from 'mobx'

export class AppStore {
  @observable online: boolean = navigator.onLine

  constructor () {
    document.addEventListener('deviceready', this.updateOnlineStatus, false)

    // window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
  }

  @action
  updateOnlineStatus = () => {
    // console.log(navigator.onLine)
    // window.open = cordova.InAppBrowser.open
    if (navigator.onLine !== this.online) {
      this.online = navigator.onLine
      if (this.online) {
        window.location.reload(true)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/appStore.tsx